import { Flex, styled } from '@driftt/dds'

export const StyledMainContentContainer = styled(Flex, {
  background: '$gray2',
  padding: '$3',
  margin: 'auto',
})
